import { Link } from "react-router-dom";

const PRINCIPLES = [
  {
    icon: "ri-archive-2-line",
    title: "结构化立档",
    text: "不堆砌标题党，而是把每场风波拆成分类、标签、时间线，让吃瓜有章法、检索有路径。",
  },
  {
    icon: "ri-eye-off-line",
    title: "克制与边界",
    text: "不做人肉、不猎奇骚扰素人、不传播未经证实的隐私细节，信息梳理止步于公序良俗红线。",
  },
  {
    icon: "ri-refund-2-line",
    title: "纠错与求真",
    text: "素材以公开报道与官方披露为底稿，标注时间与来源性质；若存争议，核实后即修正或下架。",
  },
];

export default function Editorial() {
  return (
    <section className="border-y border-background-300/70 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 grid gap-10 lg:gap-16 lg:grid-cols-2 lg:items-center">
        <div>
          <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600 uppercase">
            <span className="h-px w-8 bg-primary-400" /> Editorial
          </p>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            我们不只是搬运瓜，<br />更是给瓜建立一套<span className="text-primary-600">检索秩序</span>
          </h2>
          <p className="mt-4 max-w-lg text-sm md:text-base leading-7 text-foreground-600">
            娱乐八卦不应该只有情绪，更应该有脉络。黑料档案坚持把事件当作「档案」来整理——
            可分类、可检索、可追溯，帮助每一个围观者做出更理性的判断。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-foreground-950 text-background-50 px-5 py-2.5 text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap"
          >
            了解档案库的定位与理念 <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>

        <div className="grid gap-3">
          {PRINCIPLES.map((p, i) => (
            <div key={p.title} className="flex gap-4 rounded-xl border border-background-300/60 bg-background-100 p-5">
              <span className={`shrink-0 grid place-items-center w-11 h-11 rounded-xl ${i === 1 ? "bg-accent-100 text-accent-700" : "bg-primary-100 text-primary-700"}`}>
                <i className={`${p.icon} text-lg`} />
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-1.5 text-sm leading-6 text-foreground-600">{p.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}